<template>
  <card-item
    card="item_info_project"
    :tabs="tabs"
    v-model="activeTab"
    :id="`${id}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          key: "info",
          component: () => import("./Info"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>